import React, { useCallback, useMemo } from "react";

import Head from "next/head";

import { useMediaQuery, Theme } from "@mui/material";

import { SecondaryLayout } from "@/layouts/secondary-layout/SecondaryLayout";
import { useTabsProps } from "@/lib/tabs/hooks";
import { useSearchParamsContextV2 } from "@/shared/search-params-context";

import { Tabs } from "../../lib/tabs/Tabs";
import { SearchPageMainContent } from "./components/SearchPageMainContent";
import { SearchPageQueryInputsParams } from "./models";

export const SearchPage: React.FC = () => {
  const { setUrlSearchParams } = useSearchParamsContextV2(
    SearchPageQueryInputsParams,
  );

  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("md"),
  );

  const memoizedTabsPropsParams = useMemo(() => {
    return [
      { label: "Search", selectedOnRoute: "/search" },
      {
        label: isMobile ? "Online" : "Top online ladies",
        selectedOnRoute: "/search?online=true",
      },
      {
        label: isMobile ? "Over 40" : "Top single over 40",
        selectedOnRoute: "/search?minAge=40",
      },
      {
        label: isMobile ? "New" : "New Profiles",
        selectedOnRoute: "/search?newest=true",
      },
      {
        label: isMobile ? "Top" : "Top 1000",
        selectedOnRoute: "/search?topLadies=true",
      },
    ];
  }, [isMobile]);

  const { onChange, ...tabsProps } = useTabsProps(memoizedTabsPropsParams);

  const onTabChange = useCallback(
    (_event: React.SyntheticEvent<Element, Event>, value: number) => {
      switch (value) {
        case 1:
          setUrlSearchParams({ online: true });
          break;
        case 2:
          setUrlSearchParams({ minAge: 40 });
          break;
        case 3:
          setUrlSearchParams({ newest: true });
          break;
        case 4:
          setUrlSearchParams({ topLadies: true });
          break;

        default:
          setUrlSearchParams({});
          break;
      }
      onChange(_event, value);
    },
    [onChange, setUrlSearchParams],
  );

  return (
    <>
      <Head>
        <title>Ukraine Brides Search - Find Ukraininan Women Now</title>
        <meta
          name="description"
          content={`Ukraine Brides Search Engine ➤ Try it! ✔100% Verified Profiles\
            ✔Free Registration ✔Safe & Secure ➤ Your Dream Wife Is Waiting At GoldenBride.net ➤ Join Us!`}
        />
      </Head>
      <SecondaryLayout
        beforeContent={
          <Tabs
            onChange={onTabChange}
            {...tabsProps}
            tabs={memoizedTabsPropsParams}
            value={tabsProps.value}
          />
        }
      >
        <SearchPageMainContent />
      </SecondaryLayout>
    </>
  );
};
